<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import deviceModel from '@/mixins/device-model';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'DevicePieChart',
  components: {
    PieChart,
  },
  mixins: [
    deviceModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      classifiedPercentage: 0,
    };
  },
  computed: {
    series() {
      if (this.rawSeries) {
        return this.rawSeries.map(([seriesTitle, seriesValue]) => {
          return {
            name: this.getDeviceName(seriesTitle),
            y: seriesValue,
            color: this.getDeviceColor(seriesTitle),
          };
        }).sort((actualValue, prevValue) => {
          if (actualValue.y < prevValue.y) return 0;
          return actualValue.y > prevValue.y ? -1 : 1;
        });
      }
      return [];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringOverview',
      })
        .then(response => {
          [this.classifiedPercentage, this.rawSeries] = response.talking_about.device;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
